import { lazy } from "react";

const Orders = lazy(() => import("../pages/orders/Orders"));
const OrderDetails = lazy(() => import("../pages/orders/OrderDetails"));

export const ordersRoutes = [
  {
    path: "/orders",
    component: Orders,
  },
  {
    path: "/orders/:id",
    component: OrderDetails,
  },
];
